export const addSvgAccessibility = (altText: string) => (svg: SVGElement) => {
  if (altText) {
    svg.setAttribute('aria-label', altText);
  }
};
